import { AdaBindMethodPipe, TemplateMarkerDirectiveModule } from '@adaptiva/core/common';
import { DynamicComponentLoaderModule } from '@adaptiva/core/loaders';
import { MathAbsPipe, MathSignPipe } from '@adaptiva/core/math';
import { AlertComponentModule } from '@adaptiva/widgets/alert';
import { ButtonComponentModule } from '@adaptiva/widgets/button';
import { CardComponentModule } from '@adaptiva/widgets/card';
import { CheckboxGroupComponentModule } from '@adaptiva/widgets/checkbox-group';
import { ComboComponentModule } from '@adaptiva/widgets/combo';
import { ContainerComponentModule } from '@adaptiva/widgets/container';
import { EditorToolbarComponentModule } from '@adaptiva/widgets/editor-toolbar';
import { InputComponentModule } from '@adaptiva/widgets/input';
import { LabelComponentModule } from '@adaptiva/widgets/label';
import { MenuComponentModule } from '@adaptiva/widgets/menu';
import { ObjectTableComponentModule } from '@adaptiva/widgets/object-table';
import { OverlayComponentModule } from '@adaptiva/widgets/overlay';
import { RadioButtonComponent } from '@adaptiva/widgets/radio-button';
import { SignpostComponentModule } from '@adaptiva/widgets/signpost';
import { TableColumnDirective, TableComponentModule } from '@adaptiva/widgets/table';
import { TextComponentModule } from '@adaptiva/widgets/text';
import { TimeScaleComponentModule } from '@adaptiva/widgets/time-scale';
import { ToggleSwitchComponent } from '@adaptiva/widgets/toggle-switch';
import { CommonModule } from '@angular/common';
import { NgModule, PipeTransform, Type } from '@angular/core';
import { RecurringByDateModule, RecurringByDayModule, RecurringByDayOfWeekModule, RecurringByIntervalModule, RecurringByLastDayModule, RecurringByWeekModule } from './components';
import { ScheduleEditorAreaComponent } from './schedule-editor-area.component';

const SCHEDULE_TYPES: Type<NgModule>[] = [
	RecurringByDateModule,
	RecurringByDayModule,
	RecurringByDayOfWeekModule,
	RecurringByIntervalModule,
	RecurringByLastDayModule,
	RecurringByWeekModule
];

const WIDGETS: Type<NgModule>[] = [
	AlertComponentModule,
	ButtonComponentModule,
	CardComponentModule,
	CheckboxGroupComponentModule,
	ComboComponentModule,
	ContainerComponentModule,
	EditorToolbarComponentModule,
	InputComponentModule,
	LabelComponentModule,
	MenuComponentModule,
	ObjectTableComponentModule,
	OverlayComponentModule,
	RadioButtonComponent,
	SignpostComponentModule,
	TableComponentModule,
	TextComponentModule,
	TimeScaleComponentModule,
	ToggleSwitchComponent,
];

const PIPES: Type<PipeTransform>[] = [
	AdaBindMethodPipe,
	MathAbsPipe,
	MathSignPipe,
];

@NgModule({
	imports: [
		...SCHEDULE_TYPES,
		CommonModule,
		DynamicComponentLoaderModule.forChild(ScheduleEditorAreaComponent),
		PIPES,
		TableColumnDirective,
		TemplateMarkerDirectiveModule,
		WIDGETS,
	],
	declarations: [ScheduleEditorAreaComponent],
	exports: [ScheduleEditorAreaComponent]
})
export class ScheduleEditorAreaComponentModule {

}
